import React from "react";

const SvgTaurus = (props) => {
  return (
    <svg
      viewBox="0 0 39.25 37"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M37.75 0c-4.23 0-6.28 2.57-8.27 5.06-2.24 2.8-4.35 5.44-9.86 5.44S12 7.86 9.77 5.06C7.78 2.57 5.73 0 1.5 0 .67 0 0 .67 0 1.5S.67 3 1.5 3c2.78 0 4.1 1.65 5.93 3.94 1.44 1.81 3.11 3.89 5.81 5.21-4.09 2.26-6.86 6.61-6.86 11.6C6.38 31.06 12.32 37 19.62 37c7.31 0 13.25-5.94 13.25-13.25 0-4.99-2.78-9.34-6.86-11.6 2.7-1.33 4.37-3.4 5.81-5.21C33.65 4.65 34.97 3 37.75 3c.83 0 1.5-.67 1.5-1.5S38.58 0 37.75 0zm-7.87 23.75c0 5.65-4.6 10.25-10.25 10.25S9.38 29.4 9.38 23.75s4.6-10.25 10.25-10.25 10.25 4.6 10.25 10.25z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgTaurus;
